import classNames from 'classnames'
import { Fragment, h, JSX } from 'preact'

import { Button, ButtonProps } from '../../components/button/button'

export interface ResponseBlockProps {
    text?: string[]
    center?: boolean
    bold?: boolean
    button?: ButtonProps
}

export const ResponseBlock = (props: ResponseBlockProps): JSX.Element => (
    <Fragment>
        {props.text && (
            <div
                className={classNames(
                    'response__content',
                    props.center && 'response__content--center',
                    props.bold && 'response__content--bold',
                )}
            >
                {props.text.map((row, index) => (
                    <p key={index} className="response__content-row">
                        {row}
                    </p>
                ))}
            </div>
        )}
        {props.button && <Button class="response__button" {...props.button} />}
    </Fragment>
)
